import { Input } from '../ui/input';

const choiceClass = (selected, isDark) => `px-4 py-2 rounded-lg text-sm transition border ${
  selected
    ? 'bg-[#81d8d0] text-black border-[#81d8d0]'
    : isDark
    ? 'bg-white/5 border-white/10 hover:bg-white/10'
    : 'bg-white border-black/10 hover:bg-black/5'
}`;

// Une question du questionnaire fiscal : single, yesno, number, amount, date, text.
export const TaxQuestion = ({ q, value, onChange, isDark, nested = false }) => {
  const label = (
    <div className="text-sm mb-2">
      {q.label}
      {q.required && <span className="text-red-400 ml-1">*</span>}
    </div>
  );
  const wrapperClass = nested ? `pl-4 border-l-2 ${isDark ? 'border-[#81d8d0]/30' : 'border-[#81d8d0]/50'}` : '';

  if (q.type === 'yesno') {
    return (
      <div data-testid={`question-${q.id}`} className={wrapperClass}>
        {label}
        <div className="flex gap-2">
          {[{ v: true, l: 'Oui' }, { v: false, l: 'Non' }].map((opt) => (
            <button
              key={String(opt.v)}
              type="button"
              onClick={() => onChange(opt.v)}
              data-testid={`q-${q.id}-${opt.v ? 'yes' : 'no'}`}
              className={choiceClass(value === opt.v, isDark)}
            >
              {opt.l}
            </button>
          ))}
        </div>
      </div>
    );
  }

  if (q.type === 'single') {
    const hasHints = q.options.some((o) => o.hint);
    return (
      <div data-testid={`question-${q.id}`} className={wrapperClass}>
        {label}
        <div className={hasHints ? 'grid grid-cols-1 sm:grid-cols-3 gap-2' : 'flex flex-wrap gap-2'}>
          {q.options.map((opt) => (
            <button
              key={opt.id}
              type="button"
              onClick={() => onChange(opt.id)}
              data-testid={`q-${q.id}-${opt.id}`}
              className={`${choiceClass(value === opt.id, isDark)} ${hasHints ? 'text-left py-3' : ''}`}
            >
              <span className={hasHints ? 'font-medium block' : ''}>{opt.label}</span>
              {opt.hint && <span className="text-xs opacity-70 block mt-1">{opt.hint}</span>}
            </button>
          ))}
        </div>
      </div>
    );
  }

  const inputType = q.type === 'date' ? 'date' : q.type === 'text' ? 'text' : 'number';
  return (
    <div data-testid={`question-${q.id}`} className={wrapperClass}>
      {label}
      <Input
        type={inputType}
        inputMode={inputType === 'number' ? 'decimal' : undefined}
        min={inputType === 'number' ? 0 : undefined}
        placeholder={q.placeholder || (q.type === 'amount' ? 'Montant en €' : '')}
        value={value ?? ''}
        onChange={(e) => {
          const raw = e.target.value;
          if (inputType === 'number') onChange(raw === '' ? null : Number(raw));
          else onChange(raw);
        }}
        data-testid={`q-${q.id}-input`}
        className={`max-w-xs ${isDark ? 'bg-white/5 border-white/10' : 'bg-white'}`}
      />
    </div>
  );
};

export default TaxQuestion;
